<ng-container *ngIf="state.categoryData as categoryData">
  <img width="360" height="290" loading="eager" class="santa-align-bottom" [src]="SLIDE_TO_IMAGE_MAP[categoryData]" alt="illustration" />
  <div class="santa-p-20 santa-pt-0 santa-text-black-800">
    <div *ngIf="state.activeCategory as activeCategory" class="santa-flex santa-items-center santa-space-x-10 santa-text-black-500 santa-cursor-pointer santa-py-5" (click)="backToList()">
      <div *ngIf="state.eventData as eventData" atsAnalyticsPushEventOnView [event]="eventData" [isOneTime]="false" class="santa--ml-10"></div>
      <div class="santa-rotate-90">
        <alliance-icon [name]="ICONS.IconArrowsVerticalDropdown20.name" [inheritColor]="true"></alliance-icon>
      </div>
      <span class="santa-typo-secondary-bold santa-py-10">{{ translations.categories[activeCategory] | translate }}</span>
    </div>
    <div class="santa-typo-regular-bold santa-mb-10">{{ translations.headings[categoryData] | translate }}</div>
    <ng-content></ng-content>
  </div>
</ng-container>
